<div class="products-grid" *ngIf="activeOrder">
    <div *ngFor="let product of _products" class="products-grid__item">
        <app-product-grid-item [product]="product" [order]="activeOrder"></app-product-grid-item>
    </div>
</div>

